module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.getSsessionUserExists) ? _c('div', {
    staticClass: "divfull"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1) : (this.$route.name == 'dashBoard') ? _c('div', {
    staticClass: "divfull"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "divfull"
  }, [_c('keep-alive', [_c('egolm-main-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "Right"
  }, [_c('div', {
    staticClass: "mainContent"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _vm._m(0, false, false)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom "
  }, [_c('div', {
    staticStyle: {
      "clear": "both",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "text-center copyright",
    staticStyle: {
      "padding": "20px 0",
      "border-top": "1px solid rgba(65, 202, 192, 0.34)"
    }
  }, [_c('strong', [_vm._v("Copyright © 2012-2019 linkfern.com, All Rights Reserved.")])]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-42234aa8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = MuW2
// module chunks = 1